var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlinkicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4762_4224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49917 8.49835H3.49936C2.83644 8.49835 2.20067 8.23501 1.73192 7.76625C1.26316 7.2975 0.999817 6.66173 0.999817 5.99881C0.999817 5.33589 1.26316 4.70012 1.73192 4.23137C2.20067 3.76261 2.83644 3.49927 3.49936 3.49927",
    stroke: "#00A63E",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49863 3.49927H8.49844C8.96264 3.49927 9.41766 3.62853 9.81253 3.87257C10.2074 4.11661 10.5265 4.46579 10.7341 4.88098C10.9417 5.29617 11.0296 5.76096 10.9879 6.22328C10.9462 6.6856 10.7766 7.12718 10.4981 7.49853",
    stroke: "#00A63E",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99927 5.99878H5.9989",
    stroke: "#00A63E",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999817 0.999756L10.998 10.9979",
    stroke: "#00A63E",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4762_4224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9978,
    height: 11.9978,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkicon);
export default __webpack_public_path__ + "static/media/unlinkicon.fc716b1500eb169434094c1f0041bc16.svg";
export { ForwardRef as ReactComponent };